/**
 * @generated SignedSource<<abb3c50999001242688495f6014af9fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LlmConversationChatV1RedirectQuery$variables = {
  conversationId: number;
};
export type LlmConversationChatV1RedirectQuery$data = {
  readonly llmConversationByConversationId: {
    readonly id?: any;
  } | null | undefined;
};
export type LlmConversationChatV1RedirectQuery = {
  response: LlmConversationChatV1RedirectQuery$data;
  variables: LlmConversationChatV1RedirectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "conversationId",
    "variableName": "conversationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LlmConversationChatV1RedirectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "llmConversationByConversationId",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/)
            ],
            "type": "GraphQLLlmConversation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LlmConversationChatV1RedirectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "llmConversationByConversationId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c2f8b4b2eba39d1eaa1f51a998a9dc2",
    "id": null,
    "metadata": {},
    "name": "LlmConversationChatV1RedirectQuery",
    "operationKind": "query",
    "text": "query LlmConversationChatV1RedirectQuery(\n  $conversationId: Int!\n) {\n  llmConversationByConversationId(conversationId: $conversationId) {\n    __typename\n    ... on GraphQLLlmConversation {\n      id\n    }\n    __isNode: __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ddf6408a70c0dc2c42364a8b09aa3cd3";

export default node;
